import { service } from '@ember/service';
import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import { not } from 'ember-truth-helpers';
import FlowsSectionsFinalScreen from 'garaje/components/flows/sections/final-screen';
import type Location from 'garaje/models/location';
import type CurrentLocationService from 'garaje/services/current-location';
import { alias } from 'macro-decorators';

import type VisitorsSettingsVisitorTypesFlowFinalScreenController from './controller';
import type { FinalScreenRouteModel } from './route';

interface VisitorsSettingsVisitorTypesFlowFinalScreenSignature {
  Args: {
    model: FinalScreenRouteModel;
    controller: VisitorsSettingsVisitorTypesFlowFinalScreenController;
  };
}

class VisitorsSettingsVisitorTypesFlowFinalScreen extends Component<VisitorsSettingsVisitorTypesFlowFinalScreenSignature> {
  @service declare currentLocation: CurrentLocationService;

  @alias('currentLocation.languagesAvailable')
  declare translationLanguagesAvailable: Location['languagesAvailable']; // boolean

  get translationEnabledLocales(): Location['enabledLocales'] {
    const enabledLocales = this.currentLocation.content?.enabledLocales || [];
    const locale = this.currentLocation.content?.locale || 'en';

    return Array.from(new Set([...enabledLocales, locale]));
  }

  <template>
    <FlowsSectionsFinalScreen
      @changeset={{@model.changeset}}
      @defaultLocale={{@model.currentLocation.locale}}
      @flow={{@model.flow}}
      @isDisabled={{not @model.flow.canEdit}}
      @isEditingCustomFinalMessage={{@controller.isEditingCustomFinalMessage}}
      @summaryAttributeChangesets={{@model.summaryAttributeChangesets}}
      @summaryPage={{@model.summaryPage}}
      @translationEnabledLocales={{this.translationEnabledLocales}}
      @translationLanguagesAvailable={{this.translationLanguagesAvailable}}
    />
  </template>
}

export default RouteTemplate(VisitorsSettingsVisitorTypesFlowFinalScreen);
